// extracted by mini-css-extract-plugin
export default {"canvas":"styles_canvas__+U8IM"};